import type { ComponentProps } from "react";

type Props = ComponentProps<"svg">;

const InStockIcon = (props: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      {...props}
    >
      <circle cx="5" cy="5" r="5" />
      {/* <path
                stroke="#fff"
                strokeWidth="2"
                d="M9 3.777 5.667 8.444 3 6.111"
            /> */}
    </svg>
  );
};

InStockIcon.displayName = "InStockIcon";

export default InStockIcon;
